import collection from './company/collection';
import item from './company/item';

const company = {
  namespaced: true,
  modules: {
    collection,
    item,
  },
};

export default company;
